(function () {
  // Shared flag: anything that mutates the upsell block ourselves (this insertion
  // function, and swatch/size selection in cart-upsell.liquid) sets this true around
  // its own DOM writes so the observer below can ignore its own side effects instead
  // of mistaking them for a real cart change and firing an unnecessary refetch.
  window.ruvrSuppressUpsellObserver = window.ruvrSuppressUpsellObserver || false

  async function insertSectionCartDrawer() {
    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
    if (!cartDrawerItems) return

    if (cartDrawerItems.classList.contains('is-empty')) return

    var upsells = document.querySelector('#cart-drawer-upsell-wrapper')
    if (!upsells) return

    window.ruvrSuppressUpsellObserver = true

    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
    if (!wrapper) {
      wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)
    }

    // Always drop any previously-inserted upsell block before inserting the fresh one.
    // Without this, repeated add-to-cart actions left stale upsell markup (and stale
    // data-variants) sitting in the DOM alongside newer copies, so swatch/size clicks
    // could resolve against the wrong (orphaned) item and silently do nothing.
    var existingUpsellBlock = wrapper.querySelector('#cart-drawer-upsell')
    if (existingUpsellBlock) existingUpsellBlock.remove()

    wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      var emptyUpsellBlock = document.querySelector('#cart-drawer-upsell')
      if (emptyUpsellBlock) emptyUpsellBlock.remove()
    }

    // Release on the next tick (a macrotask), so the MutationObserver's callback —
    // which runs as a microtask right after this function returns — still sees the
    // flag as true for the mutations just made above.
    setTimeout(function () {
      window.ruvrSuppressUpsellObserver = false
    }, 0)
  }
  // Exposed so cart-drawer.js can call this synchronously right after it swaps in
  // fresh content, instead of relying solely on the debounced observer below.
  window.ruvrInsertCartDrawerUpsell = insertSectionCartDrawer
  insertSectionCartDrawer()

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault()
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg

    if (imgSrc) {
      const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
      img.src = imgSrc
    }
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer')
    if (!element) return

    let timer

    const observer = new MutationObserver((mutations) => {
      // Skip entirely if this mutation batch was caused by our own upsell code
      // (selecting a color/size swatch updates that button's class, the meta text,
      // and the thumbnail image — all real DOM mutations). Without this check, that
      // self-inflicted change would still trigger the refetch below ~250ms later,
      // overwriting the user's in-progress selection with the server's default state.
      if (window.ruvrSuppressUpsellObserver) return

      if (timer) clearTimeout(timer)

      timer = setTimeout(async () => {
        const respoonse = await fetch(window.location.href)
        const text = await respoonse.text()
        const newDocument = new DOMParser().parseFromString(text, 'text/html')

        document.querySelector('#cart-drawer-upsell-wrapper')
          .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

        insertSectionCartDrawer()
      }, 250)
    })

    observer.observe(element, {
      childList: true,
      subtree: true
    });
  }
  listenCartDrawer()

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items')
    if (!element) return

    let timer

    const observer = new MutationObserver((mutations) => {
      if (window.ruvrSuppressUpsellObserver) return

      if (timer) clearTimeout(timer)

      timer = setTimeout(async () => {
        const respoonse = await fetch(window.location.href)
        const text = await respoonse.text()
        const newDocument = new DOMParser().parseFromString(text, 'text/html')

        document.querySelector('#cart-drawer-upsell-wrapper')
          .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

        // insertSectionCartPage was left commented out above (never implemented) — guard
        // so this observer doesn't throw a ReferenceError if it ever fires on the cart page.
        if (typeof insertSectionCartPage === 'function') insertSectionCartPage()
      }, 250)
    })

    observer.observe(element, {
      childList: true,
      subtree: true
    });
  }
  listenCartPage()
})();
